import "./ImageSetting.css"
import { useSelector, useDispatch } from "react-redux"
import { setZoom, setRotate } from "../../../actions"
import rotatePic from "../../../assets/rotate.png"
import zoomPic from "../../../assets/zoom.png"

const ImageSetting = () => {

    const zoom = useSelector(state => state.image.zoom)
    const rotate = useSelector(state => state.image.rotate)
    const dispatch = useDispatch()

    const handleZoomChange = (e) => {
        let realZoom = e.target.value > 10 ? e.target.value/10 : 1
        dispatch(setZoom(realZoom))
    }

    const handleRotateChange = (e) => {
        dispatch(setRotate(e.target.value))
    }

    return(
        <div className="ImageSetting">
            <div className="slider">
                <input type="range" min="10" max="100" onChange={handleZoomChange} value={zoom*10}/>
                <img src={zoomPic} alt="" />
            </div>
            <div className="slider">
                <input type="range" min="-180" max="180" onChange={handleRotateChange} value={rotate}/>
                <img src={rotatePic} alt="" />
            </div>
        </div>
    )
}

export default ImageSetting